import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { fileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';
import { NestedPageLayout } from '#apps/client-web/app/components/nested-page-layout';

import { AuditFormWaterFixturePageContainer } from './audit-form-water-fixture-page.container';
import { useAuditFormWaterFixturePageViewModel } from './audit-form-water-fixture-page.view-model';

export const AuditFormWaterFixturePage = () => {
  const logger = useLogger('pages/audit-form-water-fixture');

  const viewModel = useAuditFormWaterFixturePageViewModel({
    auditFormService,
    fileStorageService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <NestedPageLayout title="Water Fixtures">
      <AuditFormWaterFixturePageContainer
        viewModel={viewModel}
        logger={logger}
      />
    </NestedPageLayout>
  );
};
